/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = TableOfContents
 *
 * 2 = Heading
 *
 * 3 = TextParagraph
 *
 * 4 = List
 *
 * 5 = DecoratedText
 *
 * 6 = Quote
 *
 * 7 = Image
 *
 * 8 = YouTubeVideo
 */
export enum BlogSectionTypes {
  TableOfContents = 1,
  Heading = 2,
  TextParagraph = 3,
  List = 4,
  DecoratedText = 5,
  Quote = 6,
  Image = 7,
  YouTubeVideo = 8,
}
